import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Domain_LocalResourcesDefinition  {
    _originalTypeClassName = "zAppDevManager.BO.Domain_LocalResourcesDefinition";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Domain_LocalResourcesDefinition.translate = translateService;
}
this.EnvironmentBO_Res_ASSOC_Environment_ImlementationStrategyInstance_Environment = null;
this.Res_ENUM_DBType_MSSQL = null;
this.Res_ENUM_DBType_MYSQL_LIKE = null;
this.Res_ENUM_DatabaseType_MSSQL = null;
this.Res_ENUM_DatabaseType_MYSQL = null;
this.Res_ENUM_DatabaseType_MARIADB = null;
this.RuntimeServerBO_Res_ASSOC_RuntimeServer_RuntimeServerResolutionRule_RuntimeServer = null;
this.RuntimeServerBO_Res_ASSOC_Environment_RuntimeServerResolutionRule_Environment = null;
}

static translate: TranslateService;
_key: any;
EnvironmentBO_Res_ASSOC_Environment_ImlementationStrategyInstance_Environment:any;
Res_ENUM_DBType_MSSQL:any;
Res_ENUM_DBType_MYSQL_LIKE:any;
Res_ENUM_DatabaseType_MSSQL:any;
Res_ENUM_DatabaseType_MYSQL:any;
Res_ENUM_DatabaseType_MARIADB:any;
RuntimeServerBO_Res_ASSOC_RuntimeServer_RuntimeServerResolutionRule_RuntimeServer:any;
RuntimeServerBO_Res_ASSOC_Environment_RuntimeServerResolutionRule_Environment:any;




}